module.exports = __webpack_public_path__ + "img/yolo13_framework.2868cd3c.png";